import * as React from "react";
import dispatchOrder from "../../api/orderApi";
import LoadingSpinner from "../UI/LoadingSpinner";
import FailedTransaction from "./FailedTransaction";
import Success from "./Success";

function DispatchCheckout({
  userData,
  resetUserData,
  cart,
  resetCart,
  totalCartPrice,
}) {
  const [orderId, setOrderId] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    async function dispatchData() {
      dispatchOrder(cart, userData, totalCartPrice, setOrderId, setError);
      resetCart();
      resetUserData();
    }
    dispatchData();
  }, [cart, resetCart, resetUserData, totalCartPrice, userData]);

  return orderId ? (
    <Success orderId={orderId} />
  ) : error ? (
    <FailedTransaction error={error} />
  ) : (
    <LoadingSpinner text="Processing transaction..." />
  );
}

export default DispatchCheckout;
